import { styled } from '@vw-marketing/us-components';

export const StyledNoDealersContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0;
  width: 100%;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.size.static400} ${({ theme }) => theme.size.static350};
  border: 1px solid ${({ theme }) => theme.colors.border?.default ?? '#c8ccd2'};
  border-radius: 16px;

  & > * {
    max-width: 100%;
    text-align: center;
  }

  & h2,
  & p {
    width: 100%;
    margin: 0;
    text-align: center;
  }

  & h2,
  & h2 * {
    font-family: vw-text, sans-serif !important;
    font-size: 20px !important; /* Figma font-size-250; theme.size.static250 resolves to 16px (token mismatch) */
  }
`;

export const StyledNoDealersIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.size.static300};
  color: ${({ theme }) => theme.colors.content.primary ?? 'currentColor'};
`;
